import styled from 'styled-components'

export const AddReturnMethodContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};
  button {
    color: ${props => props.theme.colors.text.default};
  }
`
